import React from 'react'
import PropTypes from 'prop-types'

import { Modal } from '../../../components/Common'

const AddToHomeScreenModal = ({ appName, show, onHide }) => {
  return (
    <Modal
      className="-homeScreenLink"
      show={show}
      onHide={onHide}
      header={
        <Modal.Header closeButton>
          <h3>Add {appName} to Your Home Screen</h3>
        </Modal.Header>
      }
    >
      <p>
        On iOS devices, load the application in Safari (homescreen link is not available on iOS
        Chrome). Then, tap the share icon followed by tapping &#34;Add to Home Screen.&#34; Enter
        the desired name for the shortcut using the on-screen keyboard and tap &#34;Add&#34;.
      </p>
      <p>
        On Android devices, tap the menu icon followed by tapping &#34;Add to Home Screen.&#34;
        Enter the desired name for the shortcut using the on-screen keyboard and tap &#34;Add&#34;.
      </p>
    </Modal>
  )
}

AddToHomeScreenModal.propTypes = {
  appName: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}

export default AddToHomeScreenModal
